import React from "react";
import "./PolicyProcessFailed.css";
import errorIcon from "../../../../images/error-icon.svg";

interface IProps {
  failureMessage: string;
  onRetry: () => void;
}

function PolicyProcessFailed({ failureMessage, onRetry }: IProps) {
  return (
    <div className="policy-process-failed-container">
      <div className="policy-process-failed-icon-wrapper">
        <img src={errorIcon} alt="" />
      </div>

      <div className="policy-process-failed-title-wrapper">
        Certificate generation failed
      </div>

      <div className="policy-process-failed-message-wrapper">
        {failureMessage}
      </div>

      <div className="policy-process-failed-retry-button-wrapper">
        <button type="button" onClick={onRetry}>
          Retry
        </button>
      </div>
    </div>
  );
}

export default PolicyProcessFailed;
